import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { FormulaireAutorisationIntervention } from 'app/models/formulaireAutorisationIntervention.model';

@Injectable({
  providedIn: 'root'
})
export class FormulaireAutorisationInterventionService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'formulaires-autorisations-interventions';

  constructor(private http: HttpClient) { }

  store(formulaireAutorisationIntervention: FormulaireAutorisationIntervention): Observable<FormulaireAutorisationIntervention> {
    return this.http.post<FormulaireAutorisationIntervention>(this.API_URL + this.MODEL_URL, formulaireAutorisationIntervention).pipe(
      catchError(err => throwError(err))
    );
  }

  update(formulaireAutorisationIntervention: FormulaireAutorisationIntervention, id: number): Observable<FormulaireAutorisationIntervention> {
    return this.http.put<FormulaireAutorisationIntervention>(this.API_URL + this.MODEL_URL + '/' + id, formulaireAutorisationIntervention).pipe(
      catchError(err => throwError(err))
    );
  }

  envoyerFormulaire(id): Observable<any> {
    return this.http.post<any>(this.API_URL + this.MODEL_URL + '/' + id + '/envoyer-par-courriel', null).pipe(
      catchError(err => throwError(err))
    );
  }
}
